// @ts-nocheck
import styles from "./TableRow.module.scss";
import React, { createRef, useEffect, useState } from 'react';
import { TableRowTrigger } from '../../../apollo/types/TableRowTrigger';

type TableRowProps = {
  tableKey?: number
  data: string[];
  isChange?: boolean;
  personalData?: string[];
  handleChangePersonalData?: Function;
  triggerChange?: Function;
  lastItemThatTriggered?: TableRowTrigger
  updateData?: Function
};


export const TableRow = ({
  tableKey,
  isChange,
  personalData,
  handleChangePersonalData,
  triggerChange,
  lastItemThatTriggered,
  data = []
}: TableRowProps) => {
  const [records, setRecords] = useState(personalData)
  const handleTriggerChange = (e, index) => {
    if(!isChange) {
      triggerChange(1, index)
    }
  }

  const numberOfInputs = personalData?.length ?? 0
  const [inputRefsArray] = useState(() =>
      Array.from({ length: numberOfInputs }, () => createRef())
  );

  useEffect(() => {
    if(isChange && lastItemThatTriggered?.tableID === tableKey) {
      const input = inputRefsArray[lastItemThatTriggered?.rowIndex].current
      input.focus();
      input.select();
    }
  }, [isChange])

  return (
    <>
      {isChange ? (
        <tr className={styles.row}>
          {inputRefsArray.map((ref, index) => (
            <td key={index} className={styles.item}>
              <input
                ref={ref}
                className={styles.input}
                type='text'
                value={records[index] ?? ''}
                onFocus={(e) => {
                   if(e.target.value === '-') {
                     e.target.value = '';
                   }
                }}
                onBlur={(e) => {
                  const { value } = e.target;
                  setRecords((records) =>
                      records.map((record, recordIndex) =>
                          recordIndex === index ? value : record
                      )
                  );
                  handleChangePersonalData(records)
                }}
                onChange={(e) => {
                  const { value } = e.target;
                  setRecords((records) =>
                      records.map((record, recordIndex) =>
                          recordIndex === index ? value : record
                      )
                  );
                  handleChangePersonalData(records)
                }}
              />
            </td>
          ))}
        </tr>
      ) : (
        <tr className={styles.row}>
          {personalData && personalData.map((item, index) => (
            <td
                key={index}
                className={styles.item}
                onClick={(e) => handleTriggerChange(e, index)}
            >{item}</td>
          ))}
          {/*{data && data.length && data.map((item, index) => (*/}
          {/*    <td*/}
          {/*        key={index}*/}
          {/*        className={styles.item}*/}
          {/*    >{item}</td>*/}
          {/*))}*/}
        </tr>
      )}
    </>
  );
};
